import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Nunca había soldado en mi vida. Con el manual arranqué desde cero y en dos semanas ya estaba fabricando rejas para vender. Recuperé la inversión el primer mes.',
    author: 'Carlos M.',
    age: '34 años',
    location: 'Lima, Perú'
  }, {
    text: 'Estaba cansado de depender de un sueldo que no alcanzaba. Empecé a hacer muebles de melamina con los planos y ya tengo clientes fijos que me encargan todos los meses.',
    author: 'Roberto G.',
    age: '41 años',
    location: 'Bogotá, Colombia'
  }, {
    text: 'Los planos de máquinas de gym me volaron la cabeza. Fabriqué un banco de pesas y una jaula de sentadillas y los vendí por más de 500 USD. Todo con materiales económicos.',
    author: 'Miguel A.',
    age: '28 años',
    location: 'Ciudad de México, México'
  }, {
    text: 'Siempre quise aprender herrería pero los cursos eran carísimos. Este pack tiene todo explicado paso a paso, con medidas y materiales. Es como tener un maestro al lado.',
    author: 'Andrés F.',
    age: '37 años',
    location: 'Quito, Ecuador'
  }, {
    text: 'Armé un trailer para mi emprendimiento de comida y me ahorré más de 2000 dólares. Los planos son exactos y fáciles de seguir. Lo recomiendo a cualquiera que quiera emprender.',
    author: 'José L.',
    age: '45 años',
    location: 'Santiago, Chile'
  }];
  return <section className="bg-gray-50 py-5 md:py-16 px-4" data-id="element-215">
      <div className="max-w-7xl mx-auto" data-id="element-216">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 mb-5 md:mb-10" data-id="element-217">
          Lo que dicen quienes ya están construyendo
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6" data-id="element-218">
          {testimonials.map((t, i) => <div key={i} className={`bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col h-full ${i === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-219">
              <div className="flex gap-1 mb-4" data-id="element-220">
                {[...Array(5)].map((_, starI) => <Star key={starI} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-221" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow text-lg" data-id="element-222">
                "{t.text}"
              </p>
              <div className="mt-auto border-t pt-4" data-id="element-223">
                <p className="font-bold text-gray-900 text-lg" data-id="element-224">{t.author}</p>
                <p className="text-sm text-gray-500" data-id="element-225">
                  {t.age} • {t.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}